import React, { useEffect, useState } from "react"
import "./Actions.css"
import { Link } from "react-router-dom"

const BASE_URL = process.env.REACT_APP_BASE_URL

const DropDownAction = props => {
  const [singlebtn, setSinglebtn] = useState(false)
  const [routes, setroutes] = useState()

  useEffect(() => {
    var rts = null
    var dgApproved = false
    var certUrl = "#"
    var showToRCertificate = false
    var finalTorUrl = "#"

    if (props.dgApproved != null && props.dgApproved === true) {
      dgApproved = true

      certUrl = BASE_URL + "verify/certificate/" + props.app_id
    }
    if (props.showToRCertificate != null && props.showToRCertificate === true) {
      showToRCertificate = true

      finalTorUrl = BASE_URL + "verify/tor/" + props.app_id
    }

    // Manual applications will only have status, view and upload certificate

    if (props.isManualApplication) {
      rts = () => {
        return (
          <>
            <Link to={"/view-application?id=" + props.appId}>
              <i className="ti-eye" title="View"></i>
            </Link>

            <Link className="linkItem" to={"/history?id=" + props.appId}>
              <i className="fas fa-history" title="History"></i>
            </Link>

            {/* {dgApproved ? <a className="linkItem" target="_blank" href={certUrl}>
              <i className="fa fa-certificate"  title="View Certificate"></i>
            </a> : null } */}

            {dgApproved ? (
              <Link className="linkItem" to={"/manual-certificate-upload?id=" + props.appId}>
                <i className="fas fa-upload" title="Upload Certificate"></i>
              </Link>
            ) : null}
          </>
        )
      }
    } else if (props.user.position_id == 1) {
      rts = () => {
        return (
          <>
            {props.viewOnly ? (
              <Link to={"/view-application?id=" + props.appId}>
                <i className="ti-eye" title="View"></i>
              </Link>
            ) : (
              <Link to={"/review-officer?id=" + props.appId}>
                <i className="ti-pencil" title="Review"></i>
              </Link>
            )}

            <Link className="linkItem" to={"/history?id=" + props.appId}>
              <i className="fas fa-history" title="History"></i>
            </Link>

            {dgApproved ? (
              <a className="linkItem" target="_blank" href={certUrl}>
                <i className="fa fa-certificate" title="View Certificate"></i>
              </a>
            ) : null}

            {showToRCertificate ? (
              <a className="linkItem" target="_blank" href={finalTorUrl}>
                <i className="ti ti-check-box" title="View ToR Certificate"></i>
              </a>
            ) : null}
          </>
        )
      }
    } else if (props.user.position_id == 2) {
      rts = () => {
        return (
          <>
            {props.viewOnly ? (
              <Link to={"/view-application?id=" + props.appId}>
                <i className="ti-eye" title="View"></i>
              </Link>
            ) : null}

            {props.isDGReturned ? (
              <Link to={"/review-hod?id=" + props.appId}>
                <i className="ti-pencil" title="Review"></i>
              </Link>
            ) : null}

            {props.hodSubmittedApps === false ? (
              <Link to={"/review-hod?id=" + props.appId}>
                <i className="ti-pencil" title="Review"></i>
              </Link>
            ) : null}

            {props.assignStaff ? (
              <Link className="linkItem" to={"/assign?id=" + props.appId}>
                <i className="ti-user" title="Assign Staff"></i>
              </Link>
            ) : (
              ""
            )}

{props.showReassign ? (
              <Link className="linkItem" to={"/assign?id=" + props.appId}>
                <i className="ti-user" title="Re-assign Staff"></i>
              </Link>
            ) : (
              ""
            )}

            <Link className="linkItem" to={"/history?id=" + props.appId}>
              <i className="fas fa-history" title="History"></i>
            </Link>

            {dgApproved ? (
              <a className="linkItem" target="_blank" href={certUrl}>
                <i className="fa fa-certificate" title="View Certificate"></i>
              </a>
            ) : null}

            {showToRCertificate ? (
              <a className="linkItem" target="_blank" href={finalTorUrl}>
                <i className="ti ti-check-box" title="View ToR Certificate"></i>
              </a>
            ) : null}
          </>
        )
      }
    } else if (props.user.position_id == 3) {
      rts = () => {
        return (
          <>
            {props.viewOnly ? (
              <Link to={"/view-application?id=" + props.appId}>
                <i className="ti-eye" title="View"></i>
              </Link>
            ) : (
              <Link to={"/review-dg?id=" + props.appId}>
                <i className="ti-pencil" title="Review"></i>
              </Link>
            )}

            <Link className="linkItem" to={"/history?id=" + props.appId}>
              <i className="fas fa-history" title="History"></i>
            </Link>

            {dgApproved ? (
              <>
              <a className="linkItem" target="_blank" href={certUrl}>
                <i className="fa fa-certificate" title="View Certificate"></i>
              </a>
              <a className="linkItem" href={"dg-recall-approved-application?id=" + props.appId}>
                <i className="fa fa-undo text-danger" title="Recall Application"></i>
              </a>
              </>
            ) : null}

            {showToRCertificate ? (
              <a className="linkItem" target="_blank" href={finalTorUrl}>
                <i className="ti ti-check-box" title="View ToR Certificate"></i>
              </a>
            ) : null}
          </>
        )
      }
    }

    setroutes(rts)
  }, [props.appId])

  return <div className="">{routes}</div>
}

export default DropDownAction
